import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ImmutableCourse as CoursePropType } from '../../../../CustomPropTypes/CoursePropTypes';
import { currentCourseSelector } from '../../../../ReduxStorage/Courses/selectors';
import {
  dismissCourseCopySuccessModal,
  dismissCourseCopyErrorModal,
  copyCourse,
} from '../../../../ReduxStorage/CourseAdmin/dispatchers';

import {
  selectShowCourseCopySuccessModal,
  selectShowCourseCopyErrorModal,
} from '../../../../ReduxStorage/CourseAdmin/selectors';
import { ConnectedCreateCourseForm } from '../../CreateCourseForm';
import { ModalDialog } from '../../../components/Modals/ModalDialog';

import './styles.scss';
import { Link } from '../../Link';
import { ROUTE_CONTACT_PAGE } from '../../../../ReduxStorage/routeActions';

import { getEnrolledInstitutionsForUser } from '../../../../ReduxStorage/Institutions/dispatchers';

class CourseCopy extends React.PureComponent {
  static propTypes = {
    course: CoursePropType.isRequired,
    showSuccessModal: PropTypes.bool.isRequired,
    showErrorModal: PropTypes.bool.isRequired,
    copyCurrentCourse: PropTypes.func.isRequired,
    dismissSuccessModal: PropTypes.func.isRequired,
    dismissErrorModal: PropTypes.func.isRequired,
    getEnrolledInstitutionsForUser: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { getEnrolledInstitutionsForUser } = this.props;
    getEnrolledInstitutionsForUser();
  }

  onCreateNewCopy = ({ courseName, coursePath, institution }) => {
    const { copyCurrentCourse } = this.props;
    const institutionPrefix = institution ? `/${institution}` : '';
    const path = `${institutionPrefix}/courses/${coursePath}`;

    return copyCurrentCourse({ path, name: courseName });
  };

  render() {
    const {
      course,
      showSuccessModal,
      dismissSuccessModal,
      dismissErrorModal,
      showErrorModal,
    } = this.props;

    return (
      <section className="bordered">
        <h3>Course Copy</h3>
        {course ? (
          <div className="create-course-form">
            <ConnectedCreateCourseForm
              // Note: this is the linked institution which is not necessarily
              // the same as the institution the course was created under
              // (i.e. the institution in the original course url)
              institution={course.get('institution', '')}
              onSubmit={this.onCreateNewCopy}
              submitButtonProps={{
                label: 'Create new copy',
              }}
            />
          </div>
        ) : null}
        <ModalDialog
          show={showSuccessModal}
          onHide={dismissSuccessModal}
          dialogClassName="course-copy-success-dialog"
          title="Success"
          actions={[
            {
              label: 'Close',
              onClick: dismissSuccessModal,
              type: 'default',
            },
          ]}
        >
          <p>
            A copy is being created in the background! Please wait up to 15
            minutes before navigating to your copied course.
          </p>
        </ModalDialog>
        <ModalDialog
          show={showErrorModal}
          onHide={dismissErrorModal}
          dialogClassName="course-copy-error-dialog"
          title="Error"
          actions={[]}
        >
          <div>
            Something went wrong. <br />
            Please contact our{' '}
            <Link className="contact-link" to={{ type: ROUTE_CONTACT_PAGE }}>
              Customer Success Team
            </Link>{' '}
            for assistance.
          </div>
        </ModalDialog>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    course: currentCourseSelector(state),
    showSuccessModal: selectShowCourseCopySuccessModal(state),
    showErrorModal: selectShowCourseCopyErrorModal(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    copyCurrentCourse: (newCourseCreationData) =>
      dispatch(copyCourse(newCourseCreationData)),
    dismissSuccessModal: () => dispatch(dismissCourseCopySuccessModal()),
    dismissErrorModal: () => dispatch(dismissCourseCopyErrorModal()),
    getEnrolledInstitutionsForUser: () =>
      dispatch(getEnrolledInstitutionsForUser()),
  };
}

const ConnectedCourseCopy = connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseCopy);

export const MountableCourseCopy = () => {
  const elem = document.getElementById('course-copy-mount');
  if (elem) {
    return ReactDOM.createPortal(<ConnectedCourseCopy />, elem);
  }

  return null;
};
